import Cookies from 'js-cookie';

const tokenKey = 'token';

export default class AuthService {
  static setToken (token, days) {
    Cookies.set(tokenKey, token, { expires: days });
  }

  static getToken() {
    return Cookies.get(tokenKey);
  }

  static isAuthorized() {
    return !!this.getToken();
  }

  static async deauthorize() {
    Cookies.remove(tokenKey);
  }
}